import { useLocale } from "./use-locale.ts";

export function useTranslation<T extends { language: string }>(
  { translations }: { translations: T[] },
  property: Exclude<keyof T, "language">,
): string | undefined {
  const currentLanguage = useLocale().split("-")[0].toUpperCase();

  if (!translations) {
    throw new Error("Translations not supplied");
  }

  const translation = translations.find(
    (it) => it.language === currentLanguage,
  )?.[property];

  const fallback = translations.find((it) => it.language === "EN")?.[property];

  if (!translation) {
    console.warn(`Missing translation for ${currentLanguage}`);
  }

  if (!fallback) {
    console.error(`Missing fallback for ${JSON.stringify(translations)}`);
  }

  return (translation ?? fallback) as string | undefined;
}
